const prefix: string = "@AXS-";

interface IPropsData {
  type: string;
  value: string;
}

interface ISessionStorage {
  key: string;
  object: Object;
}

/* Lista de Telas */
export const displayList = [
  {
    type: prefix + "home",
    value: "",
    pathName: "/",
    description: "Dados básicos",
    message: "Inicie com a simulação de economia de energia",
  },
  {
    type: prefix + "appVersion",
    value: "",
    pathName: "home",
    description: "Versão",
    message: "",
  },
  {
    type: prefix + "consumo",
    value: "",
    pathName: "/step/1",
    description: "Confirme seu consumo",
    message: "Confirme seu consumo",
  },
  {
    type: prefix + "economia",
    value: "",
    pathName: "/step/2",
    description: "Detalhes da economia",
    message: "Detalhes da economia",
  },
  {
    type: prefix + "holderdata",
    value: "",
    pathName: "/step/3",
    description: "Dados do titular",
    message: "Informe os dados do titular",
  },
  {
    type: prefix + "adesao",
    value: "",
    pathName: "/step/4",
    description: "Aceitar contrato",
    message: "Clique em prosseguir para aceitar o contrato",
  },
  {
    type: prefix + "commercial",
    value: "",
    pathName: "/representative",
    description: "",
    message: "",
  },
  {
    type: prefix + "commercial",
    value: "",
    pathName: "/indicate",
    description: "",
    message: "",
  },
  {
    type: prefix + "commercial",
    value: "",
    pathName: "/card",
    description: "",
    message: "",
  },
  {
    type: prefix + "card",
    value: "",
    pathName: "/",
    description: "",
    message: "",
  },
  {
    type: prefix + "block",
    value: "",
    pathName: "/block",
    description: "",
    message: "",
  },
  {
    type: prefix + "bancos",
    value: "",
    pathName: "/step/3",
    description: "",
    message: "",
  },
  {
    type: prefix + "success",
    value: "",
    pathName: "/step/4",
    description: "",
    message: "",
  },
  {
    type: prefix + "repprovedlink",
    value: "",
    pathName: "/repprovedlink",
    description: "",
    message: "",
  },

];

export function writeStorage(props: ISessionStorage) {
  sessionStorage.setItem(prefix + props.key, JSON.stringify(props.object));
}

export function setAllItems() {
  displayList.map((item) => {
    if (!sessionStorage.getItem(item.type)) {
      sessionStorage.setItem(item.type, JSON.stringify(""));
    }
    return item.type;
  });
}

export function getAllItems() {
  for (let i = 0, len = sessionStorage.length; i < len; i++) {
    let key = sessionStorage.key(i);
    if (key) {
      let value = sessionStorage[key];
      let item = displayList.find(({ type }) => type === key);
      if (item) {
        item.value = JSON.parse(value);
      }
    }
  }
}

export function setDataStorage(props: Array<IPropsData>) {
  props.forEach((element) => {
    const value: string | null = sessionStorage.getItem(element.type);
    if (value) {
      element.value = JSON.parse(value);
    }
  });
  return props;
}

export function readDataStorage(key: string) {
  const value = displayList.find(({ type }) => type === prefix + key);
  if (value && sessionStorage.getItem(value.type)) {
    const data: string | null = sessionStorage.getItem(value.type);
    if (data) {
      return JSON.parse(data);
    }
  }
  return {};
}
